import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useStartAppRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    const startParam = tg?.initDataUnsafe?.start_param;

    if (startParam && startParam.startsWith("friend_")) {
      const friendId = startParam.replace("friend_", "");
      // ✅ Redirect to root with friend as query param
      navigate(`/?friend=${friendId}`);
    }
  }, [navigate]);
};

export default useStartAppRedirect;